<template>
  <section class="flex flex-column flex-justify-start p-2">
    <article class="flex flex-column flex-justify-start flex-align-start">
      <h1>{{ $t('header.youtube') }}</h1>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <div class="justify-content-60 article-text">
        <h4>
          {{ $t('youtube.title') }}
        </h4>
        <div v-if="Object.keys(this.channelInfo).length > 0">
          <div>
            <a title="Youtube" target="_blank" class="page-content-link pb-2" href="https://www.youtube.com/@JulioScheidt?sub_confirmation=1">
              <b>@{{ this.channelInfo.name || '' }}</b>
            </a>
            <p>
              {{ this.channelInfo.description || '' }}
            </p>
          </div>
          <div class="flex flex-column flex-justify-center flex-align-center page-content-wrapper">
            <div class="pb-2">
              <img :src="this.channelInfo.thumbnail" alt="Founder" class="page-content-round-image">
            </div>
            <div>
              <p class="mb-0">
                {{ $t('youtube.subscribers') }}
                <b>{{ subscribersFormatted }}</b>
              </p>
              <p class="mb-0">
                {{ $t('youtube.views') }}
                <b>{{ viewsFormatted }}</b>
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          {{ $t('youtube.loading') }}...
        </div>
      </div>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <div class="justify-content-60 article-text">
        <h4>
          {{ $t('youtube.latest_videos') }}
        </h4>
        <div v-if="this.latestVideos.length > 0" class="flex flex-wrap">
          <div v-for="video in this.latestVideos" :key="video.id" class="flex flex-column flex-justify-center mb-2 page-content">
            <a
              title="Youtube"
              target="_blank"
              class="flex flex-column flex-align-start page-content-link"
              :href="`https://www.youtube.com/watch?v=${video.id}`"
            >
              <p class="mt-2 mb-2 page-content-title">
                <b>{{ video.title }}</b>
              </p>
              <div class="pb-4">
                <img :src="video.thumbnail" alt="Thumbnail" class="page-content-thumbnail">
              </div>
            </a>
          </div>
        </div>
        <div v-else>
          {{ $t('youtube.loading') }}...
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { getChannelInfo } from '@/services/api'
import humanFormat from 'human-format'

export default {
  computed: {
    ...mapGetters([]),
    ...mapState(['channelInfo', 'latestVideos']),
    subscribersFormatted() {
      return this.channelInfo && humanFormat(Number(this.channelInfo.subscribers), { maxDecimals: 1 }) || ''
    },
    viewsFormatted() {
      return this.channelInfo && humanFormat(Number(this.channelInfo.views), { maxDecimals: 1 }) || ''
    },
  },
  data() {
    return {
      channelId: 'UCHkkpZ7unPtC9sjzIF2jD1A',
    }
  },
  methods: {
    ...mapActions(['setChannelInfo', 'setLatestVideos']),
    humanFormat,
  },
  async mounted() {
    if (Object.keys(this.channelInfo).length === 0 || this.latestVideos.length === 0) {
      const { info, videos } = await getChannelInfo(this.channelId);
      this.setChannelInfo(info);
      this.setLatestVideos(videos);
    }
  },
  beforeDestroy() {},
}
</script>

<style scoped>
section {
  min-height: calc(100vh - 80px);
  width: auto;
}

section > article {
  height: auto;
  padding: 10px;
}

section > article > div {
  height: 100%;
  padding: 40px;
  border-radius: 1em;
  background: #efefef;  /* fallback for old browsers */
  background: -webkit-linear-gradient(145deg, #efefef 25%, #fff 100%);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(145deg, #efefef 25%, #fff 100%); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.article-text {
  animation: slide-up 1s ease;
}

section > article > p {
  font-size: 14px;
}

.page-content-link {
  box-sizing: border-box;
  border-radius: 0.3em;
  text-align: center;
  cursor: pointer;
  transition: background-color .35s, transform .35s;
  text-decoration: none;
  color: #000;
}

.page-content-wrapper {
  width: fit-content;
}

.page-content-round-image {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, .25);
}

.page-content {
  width: fit-content;
  transition: .5s;
}

.page-content:hover {
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, .25);
  background-color: rgba(0, 0, 0, 0.1);
  transform: scale(1.025);
}

.page-content-title {
  width: 100%;
  max-width: 320px;
  text-align: center;
}

.page-content-thumbnail {
  width: 100%;
  max-width: 320px;
  height: auto;
  border-radius: 1em;
  box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, .25);
}
</style>